
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"var(--theme-color-white-text)"}},[_c('path',{attrs:{"d":"M7.297 5.792a.612.612 0 00-.598-.625H3.094c-.33 0-.597.28-.597.625s.267.625.597.625H6.7c.33 0 .598-.28.598-.625zM3.122 7.667a.625.625 0 100 1.25h2.132a.625.625 0 100-1.25H3.122zM3.122 9.778a.625.625 0 100 1.25h2.132a.625.625 0 100-1.25H3.122z"}}),_c('path',{attrs:{"d":"M5.48 14.75H2.5c-.69 0-1.25-.56-1.25-1.25v-11c0-.69.56-1.25 1.25-1.25h7.684c.69 0 1.25.56 1.25 1.25v1.177a.625.625 0 101.25 0V2.5c0-1.379-1.121-2.5-2.5-2.5H2.5A2.503 2.503 0 000 2.5v11C0 14.879 1.121 16 2.5 16h2.98a.625.625 0 100-1.25z"}}),_c('path',{attrs:{"d":"M9.56 2.667H3.121a.625.625 0 100 1.25h6.437a.625.625 0 100-1.25z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.848 8.186c0 .205-.186.372-.415.372-.228 0-.414-.167-.414-.372v-.744c0-.754-.68-1.365-1.519-1.365-.839 0-1.519.611-1.519 1.365v.744c0 .205-.186.372-.414.372-.229 0-.415-.167-.415-.372v-.744c0-1.165 1.052-2.109 2.348-2.109 1.296 0 2.348.944 2.348 2.109v.744z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.555 8.856l.442 5.953c.023.309-.098.611-.332.837a1.314 1.314 0 01-.908.354H8.243c-.344 0-.672-.128-.908-.354a1.053 1.053 0 01-.332-.837l.442-5.953c.043-.587.586-1.042 1.24-1.042h5.63c.654 0 1.197.455 1.24 1.042zm-2.682 1.155c-.244.46-.767.78-1.373.78s-1.129-.32-1.373-.78c-.098-.186-.345-.265-.552-.176-.207.087-.294.31-.197.495.377.713 1.186 1.205 2.122 1.205.936 0 1.745-.492 2.122-1.205.097-.185.01-.408-.197-.495-.207-.089-.454-.01-.552.176z"}})])])
          )
        }
      }
    